import { useRouteView } from "../../ducks/app/dispatching/hooks";
import { useSelector } from "../../redux-store";
import * as cargoViewSelectors from "../../ducks/data/cargo-views/selectors";
import { selectClient } from "../../ducks/data/clients/selectors";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getLocationText } from "../../Components/dispatching-planning/common/cargo-combine-util";
import { useShowCargoModal } from "../../hooks";
import ListAltIcon from "@mui/icons-material/ListAlt";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Stop } from "../../ducks/data/cargo-views/types";
import { formatCustomDateString } from "../../helpers/date-helper";
import LiteVersionNoContent from "./LiteVersionNoContent";

// TODO: copied from CargoCard.tsx
const formatDateTime = (cargo: Stop | null, timeMinimised = false): string => {
  let d = cargo?.date ? formatCustomDateString(cargo?.date, "dd/MM") : "--/--";
  if (cargo?.time) {
    if (!timeMinimised) {
      d += ` (${cargo?.time})`;
    } else {
      d += ` (${cargo?.time.slice(0, 2)}:${cargo?.time.slice(3, 5)})`;
    }
  }
  return d;
};

const LiteVersionCargoList = ({ routeId }: { routeId: string }) => {
  let items = useRouteView(routeId).items;
  const { t } = useTranslation("dispatching");

  if (!items.length) {
    return <LiteVersionNoContent text={t("liteVersion.noCargos")} />;
  }

  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <LiveVersionCargoCard cargoId={item} key={item} />
      ))}
    </div>
  );
};

const LiveVersionCargoCard = ({ cargoId }: { cargoId: string }) => {
  const cargo =
    useSelector(cargoViewSelectors.selectCargoView(cargoId)) || null;
  const openCargoModal = useShowCargoModal();
  const client = useSelector(selectClient(cargo?.clientId || null));
  const p = cargo?.firstStop;
  const d = cargo?.lastStop;

  const longLocationInfo = useMemo(() => {
    if (!p || !d) {
      return null;
    }
    return `${getLocationText(p as any, true) || p?.place} - ${getLocationText(d as any, true) || d?.place || ""}`;
  }, [d, p]);

  const dateInfo = useMemo(
    () => formatDateTime(p) + " - " + formatDateTime(d),
    [d, p]
  );

  if (!cargo) {
    return null;
  }

  return (
    <div
      className="flex gap-4 items-start cursor-pointer bg-gray-100 rounded-md py-2 px-4"
      onClick={() => openCargoModal(cargoId)}
    >
      <ListAltIcon style={{ color: "var(--gray-400)" }} />
      <div className="flex-grow">
        {client ? <div>{client.client}</div> : null}
        <div style={{ color: "var(--gray-500)" }}>{longLocationInfo}</div>
        <div style={{ color: "var(--gray-500)" }}>{dateInfo}</div>
      </div>
      <EditOutlinedIcon style={{ color: "var(--gray-400)" }} />
    </div>
  );
};

export default LiteVersionCargoList;
